import { axiosApi } from '@accor/customer-core'
import { API_GET_REPORTS, API_POST_REPORT_EMBED } from '@/constants/urls'
import type { ReportEmbedResponse, ReportsResponse } from '@/types/reports.types'
import type { AxiosResponse } from 'axios'

export const getReports = async (): Promise<AxiosResponse<ReportsResponse>> =>
  await axiosApi.get(API_GET_REPORTS)

export const postReportEmbedUrl = async (
  dashboardId: string
): Promise<AxiosResponse<ReportEmbedResponse>> =>
  await axiosApi.post(API_POST_REPORT_EMBED(dashboardId))
